// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1V64R","content":"LayoutSettings_content__2qHE3"};